import React from 'react';

export const orderReturnCheckInConfig = [
  {
    path: '/check-in',
    component: React.lazy(() => import('./listing/listing')),
  },
  {
    path: '/check-in/overview-checkin',
    component: React.lazy(() => import('./overviewCheckin/overviewCheckin')),
  },
  {
    path: '/acceptance/overview-acceptance',
    component: React.lazy(() => import('./overviewAcceptance/add/add')),
  },
  {
    path: '/check-in/overview-acceptance/view',
    component: React.lazy(() => import('./overviewAcceptance/view/view')),
  },

  // {
  //   path: '/assign-pic/rincian-order-cash-return-assign',
  //   component: React.lazy(() =>
  //     import('./rincianOrderAssign/rincianOrderAssign'),
  //   ),
  // },
];
